var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftCardNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1100_36705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8764 7.0686C9.53091 7.0686 9.15327 7.19271 8.8926 7.48681C8.55122 7.87194 8.44419 9.02286 8.45686 9.60368C9.03327 9.61763 10.1353 9.60235 10.5818 9.1584C11.0486 8.69414 11.1763 7.88291 10.6799 7.38922C10.4639 7.17435 10.1754 7.0686 9.8764 7.0686V7.0686Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47666 7.0686C5.82215 7.0686 6.19979 7.19271 6.46046 7.48681C6.80184 7.87194 6.90887 9.02286 6.8962 9.60368C6.31979 9.61763 5.21769 9.60235 4.77128 9.1584C4.30446 8.69414 4.17671 7.88291 4.67312 7.38922C4.88918 7.17435 5.17764 7.0686 5.47666 7.0686V7.0686Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7677 6.29929C12.6443 7.17088 12.7611 8.54463 12.1605 9.60365H24V5.73637C24 4.52257 23.0142 3.53857 21.7982 3.53857H8.44611V5.91155C9.52518 5.30268 10.8887 5.42519 11.7677 6.29929C10.8887 5.42519 12.2671 6.79586 11.7677 6.29929Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21636 13.9293L4.124 12.844L5.82108 11.1421H0V18.2638C0 19.4776 0.985795 20.4616 2.20179 20.4616H6.90482V12.236L5.21636 13.9293Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52308 11.1421L11.1975 12.8299L10.1024 13.9124L8.44611 12.2429V20.4616H21.7982C23.0142 20.4616 24 19.4776 24 18.2638V11.1421H9.52308Z",
    fill: "#ABB5BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19041 9.60365C2.58974 8.54447 2.70672 7.17083 3.58318 6.29929C4.4622 5.42519 5.82569 5.30273 6.90482 5.91155V3.53857H2.20179C0.985795 3.53857 0 4.52257 0 5.73637V9.60365H3.19041Z",
    fill: "#ABB5BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1100_36705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCardNormal);
export default __webpack_public_path__ + "static/media/gift-card-normal.9bc2c582b956ce38ec3adfe1de83f9db.svg";
export { ForwardRef as ReactComponent };